import React, { useEffect, useState } from 'react';
import ClipboardJS from 'clipboard';
import {
    Button,
} from "@mui/material";
import FileCopyIcon from '@mui/icons-material/FileCopy';
import AlertBox from './AlertBox';

const CopyButton = ({ textToCopy, labelName, uniqueId }) => {

  const [openCopyAlert, setOpenCopyAlert] = useState(false);

  useEffect(() => {
    const clipboard = new ClipboardJS(`#copy-button-${uniqueId}`, {
      text: () => textToCopy,
    });

    clipboard.on('success', (clipboardEvent) => {
      console.log('Text copied to clipboard');
      setOpenCopyAlert(true);
      clipboardEvent.clearSelection();
    });

    clipboard.on('error', (e) => {
      console.error('Unable to copy text to clipboard', e);
    });

    // Clean up the clipboard instance when the component is unmounted
    return () => clipboard.destroy();
  }, [textToCopy, uniqueId]);

  return (
    <div className='custom-button'>
      {labelName}
      <Button
        id={`copy-button-${uniqueId}`}
        endIcon={<FileCopyIcon />}
      >
        {textToCopy}
      </Button>
      <AlertBox severity='success' messageAlert='Copiado en el portapapeles!' setOpenAlert={setOpenCopyAlert} openAlert={openCopyAlert} hideDuration={2000} />
    </div>
  );
};

export default CopyButton;
